import react,{useState} from "react"
import Login from "./Component/Login";
import SignIn from "./Component/SignIn";
import Navbar from "./Component/Navbar";
import MyRoutes from "./Router/MyRoutes";
import Home from "./Component/Home";
import Steps from "./Component/Steps";
import { useLocation } from 'react-router-dom';
function App() {
  const [condition,setCondition]=useState(false)
  const location = useLocation();
  const { pathname } = location;

  // Extract the "/room" path
  const roomPath = "/room";
  const isRoom = pathname.includes(roomPath);
 
  return (
    <div>
   
      {!isRoom && <Navbar />}

      <MyRoutes/>
     
    </div>
  );
}

export default App;
